var HomeButtonComponent = /** @class */ (function () {
    function HomeButtonComponent() {
    }
    return HomeButtonComponent;
}());
export { HomeButtonComponent };
